import { Stack } from '@chakra-ui/react'
import useIsAdmin from '../../hooks/useIsAdmin'
import {
  AddHelpForm,
  DeleteHelpDialog,
  HelpHeader,
  HelpList,
} from './components'
import { useAddHelpItem, useDeleteHelpItem, useHelpData } from './hooks'

const HelpPage = () => {
  const isAdmin = useIsAdmin()
  const { docs, col } = useHelpData()
  const { question, answer, setQuestion, setAnswer, handleSubmit } =
    useAddHelpItem(col)
  const { deletingId, openDeleteDialog, closeDeleteDialog, confirmDelete } =
    useDeleteHelpItem(col)

  return (
    <Stack spacing={6}>
      <HelpHeader />
      {isAdmin && (
        <AddHelpForm
          question={question}
          answer={answer}
          onQuestionChange={setQuestion}
          onAnswerChange={setAnswer}
          onSubmit={handleSubmit}
        />
      )}
      <HelpList docs={docs} isAdmin={isAdmin} onDelete={openDeleteDialog} />
      <DeleteHelpDialog
        isOpen={!!deletingId}
        onClose={closeDeleteDialog}
        onConfirm={confirmDelete}
      />
    </Stack>
  )
}

export default HelpPage
